import { useQuery } from "@tanstack/react-query";

import { useContainer } from "@contexts/container-context";
import { useCurrentUser } from "@hooks/queries/account";

/**
 * Whether Organization Programs is enabled for the current user's organization.
 * The backend resolves parent organizations (on when any child is on), so this
 * is a single call, keyed by organizationCode so an org switch never serves a
 * stale value. Resolves to `false` until loaded.
 */
export const useOrganizationProgramsEnabled = (options = {}) => {
  const { organizationService } = useContainer();
  const currentUser = useCurrentUser();
  const orgCode = currentUser?.organizationCode;

  return useQuery({
    queryKey: ["organizationProgramsEnabled", orgCode],
    queryFn: async () => {
      const response = await organizationService.getProgramsFeatureEnabled();
      return response?.enabled === true;
    },
    ...options,
    enabled: !!orgCode && options.enabled !== false,
  });
};

export const useOrganizationPrograms = ({ selected } = {}, options = {}) => {
  const { organizationService } = useContainer();
  const currentUser = useCurrentUser();
  const orgCode = currentUser?.organizationCode;

  return useQuery({
    queryKey: ["organizationPrograms", orgCode, selected ?? null],
    queryFn: () =>
      organizationService.getOrganizationProgramTemplates(orgCode, {
        selected,
      }),
    ...options,
    enabled: !!orgCode && options.enabled !== false,
  });
};
